module.exports = __webpack_public_path__ + "img/banner.cb82c635.png";